<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('admin.migration_activities.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        :footer="null"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <div class="form-container">
            <migration-activities-table
                :migration_id="migration_id"
                :current_migration_status="current_migration_status"
            />
        </div>
    </a-modal>
</template>

<script>
import MigrationActivitiesTable from '@/components/tables/MigrationActivities.vue';

export default {
    components: {
        MigrationActivitiesTable,
    },
    data() {
        return {
            modal_visible: false,
        };
    },
    props: {
        migration_id: {
            type: Number,
            default: 0,
        },
        current_migration_status: {
            type: String,
            default: 'pending',
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
    },
};
</script>
